import { AiOutlineHome, AiOutlineShoppingCart } from "react-icons/ai";
import { BsBoxSeam } from "react-icons/bs";
import { BiPurchaseTag } from "react-icons/bi";
import { MdPayment, MdAutorenew, MdInventory, MdSettings } from "react-icons/md";
import { LuBuilding2, LuGitPullRequest, LuLayoutDashboard, LuWarehouse } from "react-icons/lu";
import { RiTaskLine, RiTruckLine } from "react-icons/ri";
import { VscOrganization } from "react-icons/vsc";
import { FaUserGroup } from "react-icons/fa6";
import { FaUser, FaUserShield } from "react-icons/fa";
import { TfiReceipt } from "react-icons/tfi";
import { FaFileContract } from "react-icons/fa";
import { GrInstall } from "react-icons/gr";
import { TbReportAnalytics, TbSitemap } from "react-icons/tb";
import { GoQuote } from "react-icons/go";
import { MdTask } from "react-icons/md";
import { CiSettings } from "react-icons/ci";

const iconSize = 22;

const menuData = {
  "Dashboard": {
    title: "Dashboard",
    icon: <AiOutlineHome size={iconSize} />,
    link: "/dashboard",
  },
  "Inventory Management": {
    title: "Inventory Management",
    icon: <AiOutlineShoppingCart size={iconSize} />,
    link: "/inventory",
  },
  "Inventory Dashboard": {
    title: "Inventory Dashboard",
    link: "", // parent + ""
    icon: <LuLayoutDashboard size={iconSize} />,
  },
  "Purchase Inventory": {
    title: "Purchase Inventory",
    link: "/purchase", // parent + /purchase
    icon: <BiPurchaseTag size={iconSize} />,
  },
  "Device SIM Mapping": {
    title: "Device SIM Mapping",
    link: "/mapping",
    icon: <TbSitemap size={iconSize} />,
  },
  "Import Data": {
    title: "Import Data",
    icon: <BsBoxSeam size={iconSize} />,
    link: "/imports",
  },
  "Billing Management": {
    title: "Billing Management",
    icon: <TfiReceipt size={iconSize} />,
    link: "/billing",
  },
  "Billing": {
    title: "Billing",
    link: "", // parent + ""
    icon: <MdAutorenew size={iconSize} />,
  },
  "Invoice": {
    title: "Invoice",
    link: "/payment",
    icon: <MdPayment size={iconSize} />,
  },
  "Quotation": {
    title: "Quotation",
    link: "/quotation",
    icon: <GoQuote size={iconSize} />,
  },
  "User Management": {
    title: "User Management",
    icon: <FaUserGroup size={iconSize} />,
    link: "/users",
  },
  "Users": {
    title: "Users",
    link: "", // parent + ""
    icon: <FaUser size={19} />,
  },
  "Users Roles": {
    title: "Users Roles",
    link: "/roles",
    icon: <FaUserShield size={iconSize} />,
  },
  "Company Management": {
    title: "Company Management",
    icon: <LuBuilding2 size={iconSize} />,
    link: "/companys",
  },
  "Company Dashboard": {
    title: "Company Dashboard",
    link: "", // parent + ""
    icon: <VscOrganization icon={iconSize} />,
  },
  "Company Requests": {
    title: "Company Requests",
    link: "/requests",
    icon: <FaFileContract icon={iconSize} />,
  },
  "Company Inventory": {
    title: "Company Inventory",
    link: "/inventory",
    icon: <LuWarehouse icon={iconSize} />,
  },
  "Vehicles Management": {
    title: "Vehicles Management",
    icon: <RiTruckLine size={iconSize} />,
    link: "/vehicles",
  },
  "Installer Management": {
    title: "Installer Management",
    icon: <TfiReceipt size={iconSize} />,
    link: "/installer",
  },
  "Installer": {
    title: "Installer",
    link: "", // parent + ""
    icon: <GrInstall size={iconSize} />,
  },
  "Inventory": {
    title: "Inventory",
    link: "/inventory",
    icon: <MdInventory size={iconSize} />,
  },
  "Requests": {
    title: "Requests",
    link: "/requests",
    icon: <LuGitPullRequest size={iconSize} />,
  },
  "Configuration": {
    title: "Configuration",
    link: "/configuration",
    icon: <MdSettings size={iconSize} />,
  },
  "Profile": {
    title: "Profile",
    link: "",
    icon: <MdSettings size={iconSize} />,
  },
  "Billing Companies": {
    title: "Billing Companies",
    link: "/billing-companies",
    icon: <TfiReceipt size={iconSize} />,
  },
  "Master Data": {
    title: "Master Data",
    link: "/master-data",
    icon: <TbSitemap size={iconSize} />,
  },
  "Task Management": {
    title: "Task Management",
    link: "/tasks",
    icon: <MdTask size={iconSize} />,
  },
  "Tasks": {
    title: "Tasks",
    link: "",
    icon: <RiTaskLine size={iconSize} />,
  },
  "Insights": {
    title: "Insights",
    link: "/dashboard",
    icon: <TbReportAnalytics size={iconSize} />,
  },
  "Settings": {
    title: "Settings",
    link: "/settings",
    icon: <CiSettings size={iconSize} />,
  }
};

export default menuData;